export let getUrlPaymentsNFTPay = [
    {address:'0X7748D7E2A2940C455DCEA7218C0676A9E95948CB',urlPayments:'https://sandbox.nftpay.xyz/iframe/iframe_pay/5be3fad7-3ccf-4cfb-adf4-5b34d1016653?'},
    {address:'0X3330A72FB2854A829DE004B1DCC6A16754FAC708',urlPayments:'https://payments.nftpay.xyz/iframe/iframe_pay/4adb0113-ccb0-437c-8fc3-f67c918d4bcb?'}
]